import type { RttsGateFields } from '../types';
import { displaySeasonLabel } from '../../../lsc/seasonDisplay';

/**
 * Build "Week 8 · Season 4 · @broadcaster" style context.
 * Reads backend (#155) keys: season_label, week_label, broadcaster_handle
 * (not season / week). Omits missing segments — never renders "Week undefined".
 */
export function formatGameContext(
  gates: Pick<RttsGateFields, 'season_label' | 'week_label' | 'broadcaster_handle' | 'edition'>
): string {
  const parts: string[] = [];
  const week = gates.week_label?.trim();
  if (week) parts.push(week);
  const season = displaySeasonLabel(gates.season_label, null, gates.edition);
  if (season) parts.push(season);
  const handle = gates.broadcaster_handle?.trim();
  if (handle) {
    parts.push(handle.startsWith('@') ? handle : `@${handle}`);
  }
  return parts.join(' · ');
}
